<template>
	<v-toolbar
		fixed app dense flat
		color="background darken-1 pr-1"
		id="gravity-toolbar">

		<Menu></Menu>

		<v-toolbar-title class="ml-0">
			<router-link to="/">
				<img src="./assets/logo.png" height="40em">
			</router-link>
		</v-toolbar-title>

		<span class="ml-2" v-if="!$user.isAdmin()">
			<v-chip
				label small
				class="px-1"
				:class="node_envs_classes[node_env]">
				<span v-if="node_env === 'production' && version">{{ version }}</span>
				<span v-else>{{ node_env }}</span>
			</v-chip>
		</span>
		<span class="ml-2" v-else>
			<v-menu offset-y>
				<template v-slot:activator="{ on }">
					<v-chip
						label small
						class="px-1"
						:class="node_envs_classes[node_env]"
						v-on="on">
						<span v-if="node_env === 'production' && version">
							{{ version }}
						</span>
						<span v-else>{{ node_env }}</span>
						<span v-if="node_env === 'development'" class="ml-1">
							{{ env_urls }}
						</span>
					</v-chip>
				</template>
				<v-list dense class="pa-0 background darken-1">
					<template v-for="env in node_envs">
						<v-list-tile
							:key="env.label"
							v-if="env.label !== node_env"
							:class="node_envs_colors[env.label]"
							:href="env.base_url + route">
							<v-list-tile-title>
								{{ env.label }}
							</v-list-tile-title>
						</v-list-tile>
					</template>
				</v-list>
			</v-menu>
		</span>

		<div class="ml-2">
			<v-tooltip bottom color="error" v-if="nexus_api_status === false">
				<template v-slot:activator="{ on }">
					<v-icon v-on="on" small color="error">
						error
					</v-icon>
					<span class="error--text caption mr-1">
						API Nexus
					</span>
				</template>
				<span>API Nexus introuvable</span>
			</v-tooltip>

			<v-tooltip bottom color="error" v-if="maestro_api_status === false">
				<template v-slot:activator="{ on }">
					<v-icon v-on="on" small color="error">
						error
					</v-icon>
					<span class="error--text caption mr-1">
						API Maestro
					</span>
				</template>
				<span>API Maestro introuvable</span>
			</v-tooltip>

			<v-tooltip bottom color="error" v-if="maestro_es_status === false">
				<template v-slot:activator="{ on }">
					<v-icon v-on="on" small color="error">
						error
					</v-icon>
					<span class="error--text caption mr-1">
						ES Maestro
					</span>
				</template>
				<span>ES Maestro introuvable</span>
			</v-tooltip>

			<v-tooltip bottom color="warning" v-if="fileopener_status === false">
				<template v-slot:activator="{ on }">
					<span v-if="fileopener_install_disabled">
						<v-icon v-on="on" small color="warning">
							error
						</v-icon>
						<span class="warning--text caption mr-1">
							Fileopener
						</span>
					</span>
				</template>
				<span>Fileopener introuvable</span>
			</v-tooltip>
		</div>

		<v-toolbar-title class="ml-2">
			<span class="headline">{{ title }}</span>
		</v-toolbar-title>

		<v-spacer></v-spacer>

		<FollowedJrs></FollowedJrs>

		<Search></Search>

		<router-link :to="{ name: 'Changelogs' }">
			<v-btn
				flat icon
				class="my-0"
				color="info accent-2"
				title="Consulter les changements">
				<v-icon>info</v-icon>
			</v-btn>
		</router-link>
		<TicketForm></TicketForm>
	</v-toolbar>
</template>

<script>
import Menu from '@/App_menu.vue'
import TicketForm from '@/pages/about/ticket_form.vue'
import FollowedJrs from '@/components/globals/followed_jrs.vue'
import Search from '@/App_search.vue'
export default {
	props: [ 'title' ],
	components: { Menu, Search, TicketForm, FollowedJrs },
	data () {
		return {
			node_env: window.appConfig._$ppt9qr,
			env_urls: process.env.ENV_URLS && process.env.ENV_URLS !== 'production' ? `[${process.env.ENV_URLS}] ` : '',
			node_envs: [
				{ label: 'production', base_url: 'https://gravity.hiventy.com' },
				{ label: 'staging', base_url: 'https://staging.gravity.hiventy.com' },
				{ label: 'development', base_url: 'http://localhost:8888' }
			],
			node_envs_classes: {
				production: 'background white--text',
				staging: 'primary color--text',
				development: 'green accent-3 color--text'
			},
			node_envs_colors: {
				production: 'white--text',
				staging: 'primary--text',
				development: 'green--text text--accent-3'
			}
		}
	},
	computed: {
		route () {
			return this.$route.fullPath
		},
		nexus_api_status () {
			return this.$store.getters.nexus_api_status
		},
		fileopener_status () {
			return this.$store.getters.fileopener_status
		},
		maestro_api_status () {
			return this.$store.getters.maestro_api_status
		},
		maestro_es_status () {
			return this.$store.getters.maestro_es_status
		},
		fileopener_install_disabled () {
			if (!this.$store.getters.nexus_api_status) return true
			if (this.$store.getters.fileopener_status) return true
			if (this.$OS === 'Windows') return true
			return false
		},
		version () {
			let hash = window.appConfig._$gzluk8
			if (hash) hash = hash.substring(0, 12)
			return hash
		}
	}
}
</script>

<style lang="stylus" scoped>
.v-toolbar
	>>>.v-toolbar__content
		padding-right: 4px

.v-list--dense
	>>>.v-list__tile
		height: 32px
		border-top: 1px solid var(--v-background-lighten2)
</style>



// WEBPACK FOOTER //
// src/App_toolBar.vue